import { MultiRiskAttibuteModelItem } from './multi-risk.attribute.model.item';

export class MultiRiskModelItem {
    public active: boolean;
    public description: string;
    public express: boolean;
    public frozenDt: number;
    public id: number;
    public name: string;
    public outcomeId: number;
    public datarobotModelId: number;
    public priority: number;
    public outcomeName: string;
    public datarobotName: string;
    public attributes: MultiRiskAttibuteModelItem[];

    constructor(data: any, attributes: any, operators: any, datarobotmodels: any, outcomes: any) {
        this.active = data.active;
        this.description = data.description;
        this.express = data.express;
        this.frozenDt = data.frozenDt;
        this.id = data.id;
        this.name = data.name;
        this.outcomeId = data.outcomeId;
        this.datarobotModelId = data.datarobotModelId;
        this.priority = data.priority;

        datarobotmodels.forEach((element: any) => {
            if (element.id === this.datarobotModelId) {
                if (this.datarobotModelId === 0) {
                    this.datarobotName = "All Models";
                } else {
                    this.datarobotName = element.description;
                }
            }
        });

        outcomes.forEach((element: any) => {
            if (element.id === this.outcomeId) {
                this.outcomeName = element.description;
            }
        });

        this.attributes = [];
        data.attributes.forEach((element: any) => {
            this.attributes.push(new MultiRiskAttibuteModelItem(element, attributes, operators));
        });
    }
}
